var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo } from 'react';
import { isAdminSite } from '../../../utils';
import { loadBerryApp } from '../helpers';
import useBerryHelpers from './useBerryHelpers';
import useLocationChangeSync from '../../../hooks/useLocationChangeSync';
function useBerry(auth, eventHandlers) {
    var _this = this;
    var helpers = useBerryHelpers();
    var isBerryChatEnabled = auth === null || auth === void 0 ? void 0 : auth.isBerryChatEnabled;
    var updateProperties = helpers.updateProperties;
    var onLocationChange = useCallback(function () {
        updateProperties({
            page_url: window.location.href,
        });
    }, [updateProperties]);
    useLocationChangeSync(onLocationChange);
    var config = useMemo(function () {
        var _a, _b;
        return ({
            name: auth === null || auth === void 0 ? void 0 : auth.user.name,
            userEmail: auth === null || auth === void 0 ? void 0 : auth.user.email,
            userId: auth === null || auth === void 0 ? void 0 : auth.user.id,
            isAdmin: isAdminSite(),
            customerId: auth === null || auth === void 0 ? void 0 : auth.customerId,
            primaryColor: auth === null || auth === void 0 ? void 0 : auth.primaryColor,
            toggleIconUrl: auth === null || auth === void 0 ? void 0 : auth.toggleIconUrl,
            berryBotUrlPath: auth === null || auth === void 0 ? void 0 : auth.berryBotUrlPath,
            isBerryChatEnabled: auth === null || auth === void 0 ? void 0 : auth.isBerryChatEnabled,
            customProps: {
                ls_name: (_a = auth === null || auth === void 0 ? void 0 : auth.company) === null || _a === void 0 ? void 0 : _a.name,
                ls_link: ((_b = auth === null || auth === void 0 ? void 0 : auth.company) === null || _b === void 0 ? void 0 : _b.learningSite) || window.location.host,
                page_url: window.location.href,
                username: auth === null || auth === void 0 ? void 0 : auth.user.username,
                user_email: auth === null || auth === void 0 ? void 0 : auth.user.email,
                user_id: auth === null || auth === void 0 ? void 0 : auth.user.id,
                cname: auth === null || auth === void 0 ? void 0 : auth.customerId,
            },
        });
    }, [auth]);
    var init = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isBerryChatEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadBerryApp(config, eventHandlers)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [config, isBerryChatEnabled, eventHandlers]);
    return __assign({ init: init }, helpers);
}
export default useBerry;
//# sourceMappingURL=useBerryChat.js.map